import { useState } from "react";
import { Platform } from "react-native";
import { WebView } from "react-native-webview";
import { useLocalSearchParams } from "expo-router";
import styled from "styled-components/native";
import { colors } from "@/lib/theme";
import { Shimmer } from "@/components/Skeleton";

const BASE_URL = "https://inthecrease.uk";

const Container = styled.View`
  flex: 1;
  background-color: ${colors.bg};
`;

const ShimmerContainer = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px 20px;
  background-color: ${colors.bg};
`;

function LegalSkeleton() {
  return (
    <ShimmerContainer>
      <Shimmer width="60%" height={28} marginBottom={16} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="85%" height={14} marginBottom={24} />
      <Shimmer width="45%" height={22} marginBottom={12} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="90%" height={14} marginBottom={8} />
      <Shimmer width="70%" height={14} marginBottom={24} />
      <Shimmer width="50%" height={22} marginBottom={12} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="100%" height={14} marginBottom={8} />
      <Shimmer width="80%" height={14} marginBottom={8} />
    </ShimmerContainer>
  );
}

export default function LegalScreen() {
  const { page } = useLocalSearchParams<{ page: string }>();
  const url = page === "privacy" ? `${BASE_URL}/privacy?inapp=1` : `${BASE_URL}/terms?inapp=1`;
  const [loading, setLoading] = useState(true);

  if (Platform.OS === "web") {
    return (
      <Container>
        {loading && <LegalSkeleton />}
        <iframe
          src={url}
          style={{ flex: 1, border: "none", width: "100%", height: "100%" }}
          onLoad={() => setLoading(false)}
        />
      </Container>
    );
  }

  return (
    <Container>
      <WebView
        source={{ uri: url }}
        style={{ flex: 1 }}
        onLoadEnd={() => setLoading(false)}
      />
      {loading && <LegalSkeleton />}
    </Container>
  );
}
